import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useModuleData(module, product) {
  return useQuery({
    queryKey: ["data", module, product],
    queryFn: async () => (await api.get(`/data/${module}`, { params: { product } })).data,
    enabled: !!product,
  });
}

export function useApi(key, path, params) {
  return useQuery({ queryKey: [key, params], queryFn: async () => (await api.get(path, { params })).data });
}
